import React from "react";
import { Card, Heading, Pagination, Select, Stack } from "@shopify/polaris";
import PropTypes from "prop-types";

const SellerListFooter = (props) => {
  const { currentPage, onPerPage, onSelectLimit, optionsList, perPageCount, sellerListCMS, totalCount } = props;

  const { label } = sellerListCMS;
  return (
    <>
      <Card.Section>
        <Stack>
          <Stack.Item fill>
            <Heading>
              {`${label.total}`}
              <span className="totalCount">{totalCount}</span>
            </Heading>
          </Stack.Item>
          <Stack.Item fill>
            <Pagination
              hasPrevious={(totalCount && currentPage !== 1 && true) || false}
              onPrevious={() => {
                if (currentPage !== 1) {
                  onPerPage(currentPage - 1);
                }
              }}
              hasNext={(currentPage < totalCount && true) || false}
              onNext={() => {
                if (currentPage <= totalCount) {
                  onPerPage(currentPage + 1);
                }
              }}
            />
          </Stack.Item>
          <Stack.Item>
            <Select value={perPageCount} options={optionsList} onChange={onSelectLimit} />
          </Stack.Item>
        </Stack>
      </Card.Section>
    </>
  );
};

SellerListFooter.defaultProps = {
  optionsList: [],
  perPageCount: "",
  totalCount: "",
  currentPage: 1,
  onSelectLimit: () => {},
  onPerPage: () => {},
};

SellerListFooter.propTypes = {
  optionsList: PropTypes.arrayOf(PropTypes.object),
  perPageCount: PropTypes.number,
  totalCount: PropTypes.number,
  onSelectLimit: PropTypes.func,
  onPerPage: PropTypes.func,
  currentPage: PropTypes.number,
  sellerListCMS: PropTypes.func.isRequired,
};

export default SellerListFooter;
